import attendance from "./attendance"

export default{
    attendance
}